"use strict";
function getHashtagFromNode(node, locale, defaultLocale) {
  var _a, _b;
  const rawText = ((_a = node.title) == null ? void 0 : _a[locale]) || ((_b = node.title) == null ? void 0 : _b[defaultLocale]) || Object.values(node.title)[0];
  if (!rawText) return "";
  const gidMatch = rawText.match(/gid:.*./);
  if (!gidMatch) return rawText;
  try {
    const decodedName = rawText.replace(/gid:\/\/.*?\/\d+\//g, "#");
    return decodedName.trim();
  } catch (error) {
    console.warn("Error decoding hashtag name:", encodedName, error);
    return rawText;
  }
}
export default getHashtagFromNode;
